export const CUSTOMER_TYPE_COMPANY = 'company'
export const CUSTOMER_TYPE_INDIVIDUAL = 'private_person'
